import { type ReactElement } from 'react';

const BatteryIcon = (): ReactElement => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_505_12621" fill="white">
      <path d="M9 4.5L9 2.25C9 1.83579 9.33579 1.5 9.75 1.5L14.25 1.5C14.6642 1.5 15 1.83579 15 2.25L15 4.5" />
    </mask>
    <path
      d="M9 4.5L10.5 4.5L10.5 2.25L9 2.25L7.5 2.25L7.5 4.5L9 4.5ZM9.75 1.5L9.75 3L14.25 3L14.25 1.5L14.25 0L9.75 0L9.75 1.5ZM15 2.25L13.5 2.25L13.5 4.5L15 4.5L16.5 4.5L16.5 2.25L15 2.25ZM14.25 1.5L14.25 3C13.8358 3 13.5 2.66421 13.5 2.25L15 2.25L16.5 2.25C16.5 1.00736 15.4926 0 14.25 0L14.25 1.5ZM9 2.25L10.5 2.25C10.5 2.66421 10.1642 3 9.75 3L9.75 1.5L9.75 0C8.50736 0 7.5 1.00736 7.5 2.25L9 2.25Z"
      fill="currentColor"
      mask="url(#path-1-inside-1_505_12621)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 5.19231L7.5 5.19231L7.5 21.0577L16.5 21.0577L16.5 5.19231ZM7.5 3.75C6.67157 3.75 6 4.39574 6 5.19231L6 21.0577C6 21.8543 6.67157 22.5 7.5 22.5L16.5 22.5C17.3284 22.5 18 21.8543 18 21.0577L18 5.19231C18 4.39574 17.3284 3.75 16.5 3.75L7.5 3.75Z"
      fill="currentColor"
    />
    <path
      d="M12.1861 12.1428L12.999 8.8125L9.375 13.353H11.818L11.001 16.6875L14.625 12.1428H12.1861Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinejoin="round"
    />
  </svg>
);

export default BatteryIcon;
